import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachejmeterComponent } from './simple-icons-apachejmeter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachejmeterComponent ],
    exports:      [ SimpleIconsApachejmeterComponent ],
    bootstrap:    []
})
export class SimpleIconsApachejmeterModule {}
